// export const tableHeaders = [
//   { label: 'Game ID', value: 'casinoGameId' },
//   { label: 'Name', value: 'name' },
//   // { label: 'Provider', value: 'casionoprovider' },
//   // { label: 'RTP', value: 'returnToPlayer' },
//   // { label: 'SUB CATEGORY', value: 'casinosubcat' },
//   { label: 'Game Category', value: 'categoryname' },
//   { label: 'Thumbnail', value: 'thumbnail' },
//   // { label: 'System', value: 'system' },
//   { label: 'Status', value: 'status' },
//   // { label: 'Bonus amount', value: 'bonus' },
//   { label: 'Bonus Status', value: 'bonusStatus' },
//   { label: 'New Game', value: 'newGame' },
//   { label: 'Is Popular', value: 'isPopular' },
//   // { label: 'Operator Status', value: 'operatorstatus' },
//   { label: 'Action', value: 'action' }
// ]


export const tableHeaders = [
  { accessorKey: 'casinoGameId', Header: 'casinoGameId', value: 'casinoGameId', label: 'Game ID' },
  { accessorKey: 'name', Header: 'name', value: 'name', label: 'Name' },
  // { accessorKey: 'casionoprovider', Header: 'casionoprovider', value: 'casionoprovider', label: 'Provider' },
  // { accessorKey: 'returnToPlayer', Header: 'returnToPlayer', value: 'returnToPlayer', label: 'RTP' },
  // { accessorKey: 'casinosubcat', Header: 'casinosubcat', value: 'casinosubcat', label: 'Sub Category' },
  { accessorKey: 'category', Header: 'category', value: 'categoryname', label: 'Game Category' },
  { accessorKey: 'thumbnails', Header: 'thumbnails', value: 'thumbnail', label: 'Thumbnail' },
  // { accessorKey: 'system', Header: 'system', value: 'system', label: 'System' },
  { accessorKey: 'isActive', Header: 'isActive', value: 'status', label: 'Status' },
  // { accessorKey: 'bonus', Header: 'bonus', value: 'bonus', label: 'Bonus Amount' },
  { accessorKey: 'bonusStatus', Header: 'bonusStatus', value: 'bonusStatus', label: 'Bonus Status' },
  { accessorKey: 'newGame', Header: 'newGame', value: 'newGame', label: 'New Game' },
  { accessorKey: 'isPopular', Header: 'isPopular', value: 'isPopular', label: 'is Trending' },
  // { accessorKey: 'operatorstatus', Header: 'operatorstatus', value: 'operatorstatus', label: 'Operator Status' },
  // { accessorKey: 'action', Header: 'action', value: 'action', label: 'Action' }
];
